import { NavLink, useRouteMatch } from "react-router-dom";

function NotificationsTabNav(): JSX.Element {
  const match = useRouteMatch();

  const tabs = [
    { to: match.url, label: "All Notifications", exact: true },
  ];

  return (
    <div className="flex gap-1 mx-5 mt-4 border-b border-dropDownBorder">
      {tabs.map((tab) => (
        <NavLink
          key={tab.label}
          to={tab.to}
          exact={tab.exact}
          className="px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors border-transparent text-textSecondaryGray hover:text-royalBlue"
          activeClassName="!border-primary !text-primary"
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}

export default NotificationsTabNav;
